module.exports = {
	"name": "London",
	"slug": "london",
	"description": "Many cities hide behind the name “London”, the historical one, the fancy one, the punk one. The city is deeply multicultural, something that can be felt through the culinary aromas on London’s streets and the diverse party places.",
	"hotspots": [
		{
			"name": "Troubadour London",
			"description": "This iconic place is known not only for being one of the remaining coffee houses of its era but also for having the famous club room in the cellar where many famous people played (Bob Dylan, Jimmy Hendrix to name some). Today, the Troubadour is a thriving cafe-bar, restaurant and club that continues to host live music and poetry. Keeping some of its traditions alive, the performers usually write their own material and present it to an intimate crowd.",
			"url": "http://www.troubadourlondon.com/",
			"lat": 51.4888522,
			"long": -0.1939071,
			"type": "coffee"
		},
		{
			"name": "Hip Hop Brunch",
			"description": "The Hip Hop Brunch is a revisited and unapologetic experience. The location is kept silent and reservations are needed to get access to this Sunday move but, once visitors get there, a delicious brunch in the form of a 3-course ‘Dirty South” meal awaits. Pair the delicious food alongside dazzling sets of hip hop karaoke and you have yourself a Londonian adventure. Secret location revealed to those who make a reservation!",
			"url": "http://www.hiphopbrunchldn.com/",
			"lat": 51.542536,
			"long": -0.148417,
			"type": "food"
		},
		{
			"name": "Brick Lane",
			"description": "Brick Lane is the home of the artistic and edgy London crowd. Popular for its galleries, restaurants (specially Indian cuisine!), markets and festivals, people can stroll around and find surprises all around. Every Sunday, visitors have the opportunity to meet with up-and-coming designers that set shop in the street as well as enjoy what vintage shops have to offer. Overall, a complete East London experience.",
			"url": "http://www.bricklanemarket.com/",
			"lat": 51.5219897,
			"long": -0.0738814,
			"type": "sightseeing"
		},
		{
			"name": "Cereal Killer Cafe",
			"description": "Bringing fun back to cereal, Cereal Killers gives the visitors a sweet time. In this quirky cafe you’ll be able to chose between the 150 cereals from all around the world, the 13 kinds of milk and the 20 different toppings. The cheerful owners invite you to try limited edition cereals and create your own crazy combinations.",
			"url": "http://www.cerealkillercafe.co.uk/menus/",
			"lat": 51.523912,
			"long": -0.0738167,
			"type": "food"
		},
		{
			"name": "Boxpark",
			"description": "The perfect place for the foodie-fashion lovers! This pop-up mall brings together the concept of street food and brands (local and global) creating a unique place, simple and industrial in spirit. Visitors will be amazed by the dozens of shipping containers that give shape to the mall and by the quality of the products they can find there. But buying and eating are not the only activities that can be enjoyed in Boxpark, over the years many artists have been invited to perform, going from Dj’s to spoken word performers.",
			"url": "http://www.boxpark.co.uk/about/",
			"lat": 51.523491,
			"long": -0.076407,
			"type": "shopping"
		},
		{
			"name": "Bounce Ping Pong",
			"description": "For those who demand more from a soiree than a few drinks and something nice to eat,  Bounce Ping Pong offers a place to socialize freely while playing some table tennis. This funky place occupies the very same site where the game was invented back in 1901 even if the modern and fluorescent decor and stylish venue wouldn’t testify to that. Enjoy playing on famous tables, like the 2014 World Championship Final table from Tokyo, then indulge in some stone-baked pizzas.",
			"url": "http://www.bouncepingpong.com/ping-pong",
			"lat": 51.5222878,
			"long": -0.1050096,
			"type": "drink"
		}
	],
	"cities": [
		{
			"name": "berlin",
			"img": "/media/img/cities/berlin_thumb.jpg",
			"url": "/city/berlin"
		},
		{
			"name": "amsterdam",
			"img": "/media/img/cities/amsterdam_thumb.jpg",
			"url": "/city/amsterdam"
		}
	],
	"media": [
		"/media/img/cities/london/london_slider-3.jpg",
		"/media/img/cities/london/london_slider-1.jpg",
		"/media/img/cities/london/london_slider-4.jpg",
		"/media/img/cities/london/london_slider-2.jpg"
	]
};


//////////////////
// WEBPACK FOOTER
// ./data/cities/london.json
// module id = 72
// module chunks = 0